<div class="dialog">
  <div mat-dialog-content class="dialog-success">
    <p class="font-bold">{{ data.message }}</p>
  </div>
  <div class="dialog-separator"></div>
  <div class="btn-button" align="end">
    <button mat-flat-button mat-dialog-close>{{'common.close' | transloco}}</button>
  </div>
</div>
